export default [
    {
        path: '',
        name: 'layananSelengkapnya',
        component: () => import('./page-layanan-selengkapnya'),
        props: true
    }
]